<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="mt-4">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-text class="py-6">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-row class="mb-0 pb-0">
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider v-slot="{ errors }" name="descricao">
                      <v-text-field
                        v-model="contrato.descricao"
                        label="Descrição"
                        title="Descrição"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Gate/Unidade Destino"
                      rules="required"
                    >
                      <v-autocomplete
                        v-if="!isUnidadeGate"
                        required
                        label="Gate/Unidade Destino"
                        :items="gates"
                        v-model="contrato.gate"
                        :item-text="getLabelEmpresa"
                        item-value="public_id"
                        return-object
                        :error-messages="errors"
                        @change="setFornecedorContrato"
                      />

                      <v-text-field
                        v-else
                        label="Gate/Unidade Destino"
                        disabled
                        required
                        :value="gates.trade_name"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Fornecedor"
                      rules="required"
                    >
                      <v-autocomplete
                        v-if="isUnidadeGate"
                        label="Fornecedor"
                        required
                        :items="fornecedores"
                        v-model="contrato.fornecedor"
                        :item-text="getLabelEmpresa"
                        item-value="public_id"
                        return-object
                        :error-messages="errors"
                        :disabled="!isUnidadeGate"
                        :readonly="!isUnidadeGate"
                        @change="handleFornecedorSelecionado"
                      />
                      <v-text-field
                        v-else
                        label="Fornecedor"
                        disabled
                        v-model="contrato.fornecedor.trade_name"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row class="mb-0 pb-0">
                  <v-col cols="12" sm="12" md="2">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Data Início"
                      rules="required"
                    >
                      <v-text-field
                        v-model="contrato.data_inicio"
                        label="Data Inicio"
                        required
                        :error-messages="errors"
                        type="date"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="2">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Data Fim"
                      rules="required"
                    >
                      <v-text-field
                        v-model="contrato.data_fim"
                        label="Data Fim"
                        required
                        :error-messages="errors"
                        type="date"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Tipo de Operação"
                      rules="required"
                    >
                      <v-autocomplete
                        label="Tipo de Operação"
                        item-text="descricao"
                        required
                        item-value="id"
                        :items="tiposOperacao"
                        v-model="contrato.tipo_operacao"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider v-slot="{ errors }" name="navio">
                      <v-autocomplete
                        label="Navio"
                        :items="naviosComOpcaoNenhum"
                        v-model="contrato.navio"
                        item-text="descricao"
                        return-object
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row class="mb-0 pb-0">
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="numero_documento"
                    >
                      <v-text-field
                        v-model="contrato.numero_documento"
                        label="Nº do documento"
                        title="Número do documento"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider v-slot="{ errors }" name="produto">
                      <v-autocomplete
                        label="Produto"
                        :items="produtos"
                        v-model="contrato.produto"
                        item-text="descricao"
                        item-value="id"
                        return-object
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider v-slot="{ errors }" name="sub produto">
                      <v-autocomplete
                        label="Sub Produto"
                        :items="subProdutos"
                        v-model="contrato.subProduto"
                        item-text="descricao"
                        return-object
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Cliente"
                      rules="required"
                    >
                      <v-autocomplete
                        required
                        label="Cliente"
                        :items="clientes"
                        v-model="contrato.cliente"
                        :item-text="getLabelEmpresa"
                        item-value="public_id"
                        return-object
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Terminal"
                      rules="required"
                    >
                      <v-autocomplete
                        label="Terminal"
                        required
                        :items="terminais"
                        v-model="contrato.terminal"
                        :item-text="getLabelEmpresa"
                        :error-messages="errors"
                        item-value="public_id"
                        return-object
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      type="number"
                      label="Quantidade (Ton)"
                      v-model="contrato.qt_peso"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <buttons-cadastro @close="close" @save="save" :disabled="invalid" />
        </v-card-actions>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import ButtonsCadastro from '../../ButtonsCadastro/ButtonsCadastro.vue'
import GateAPI from '@/services/tenants/gates'
import DistribuicaoAPI from '@/services/distribuicao'
import Perfil from '@/utils/perfil'
import ContratoAPI from '@/services/tenants/contratos'
import moment from 'moment'

export default {
  name: 'CadastroContrato',

  components: {
    ButtonsCadastro,
  },

  data() {
    return {
      overlay: false,
      produtos: [],
      subProdutos: [],
      navios: [],
      terminais: [],
      gates: [],
      contrato: {
        public_id: '',
        numero_documento: '',
        data_inicio: '',
        data_fim: '',
        fornecedor: '',
        navio: null,
        gate: null,
        cliente: null,
        terminal: null,
        tipo_operacao: 1,
        qt_peso: 0,
      },
    }
  },

  computed: {
    ...mapState('patio', ['tiposOperacao', 'navios']),
    ...mapState('fornecedores', ['fornecedores']),
    ...mapState('clientes', ['clientes']),
    ...mapState('auth', ['empresaAtual', 'perfilAtual']),

    isUnidadeGate() {
      return this.empresaAtual.gate && this.perfilAtual == Perfil.Unidade
    },
    naviosComOpcaoNenhum() {
      return [{ descricao: 'Nenhum', id: null }, ...this.navios]
    },
  },

  async created() {
    this.overlay = true
    try {
      await Promise.all([
        this.getTipoOperacao(),
        this.getClientes(),
        this.getFornecedores(),
        this.getGates(),
        this.getNavios({ tenant: this.empresaAtual.public_id }).then(
          (navios) => (this.navios = navios)
        ),
      ])

      if (this.isUnidadeGate) {
        this.gates = this.gates.find(
          (gate) => gate.public_id === this.empresaAtual.public_id
        )
      }

      const today = new Date().toLocaleDateString('pt-BR')
      const [dia, mes, ano] = today.split('/')

      this.contrato.data_inicio = `${ano}-${mes}-${dia}`
      this.contrato.data_fim = `${ano}-${mes}-${dia}`
    } finally {
      this.overlay = false
    }
  },

  methods: {
    ...mapActions('patio', ['addContrato', 'getTipoOperacao', 'getNavios']),
    ...mapActions('fornecedores', ['getFornecedores']),
    ...mapActions('clientes', ['getClientes']),
    ...mapActions('template', ['errorMessage', 'successMessage']),

    getLabelEmpresa(item) {
      return `${item.business_name} ${item.cnpj}`
    },

    async getGates() {
      try {
        const gates = await GateAPI.getByParams({
          fornecedor_tenant: this.empresaAtual.public_id,
        })

        this.gates = gates || []
      } catch (error) {
        console.error('Erro ao obter gates/unidades', error)
        this.errorMessage('Erro ao obter gates/unidades.')
      }
    },

    async handleGetTerminais(fornecedor) {
      try {
        const terminais = await ContratoAPI.getContratos(
          fornecedor.fornecedor_id,
          {
            perfil: Perfil.Terminal,
          }
        )
        this.terminais = terminais
      } catch (error) {
        this.errorMessage('Erro ao obter Terminais.')
        console.error('Erro ao obter Terminais.', error)
      }
    },

    async setFornecedorContrato() {
      if (!this.contrato.gate?.fornecedores) return

      const fornecedor = this.contrato.gate.fornecedores.find(
        (f) => f.fornecedor_id === this.empresaAtual.public_id
      )

      if (fornecedor) {
        this.contrato.fornecedor = fornecedor
        await this.setOpcoesDoFornecedor(fornecedor)
      }
    },

    async setOpcoesDoFornecedor(fornecedor) {
      await this.handleGetTerminais(fornecedor)

      this.produtos = fornecedor.produtos || []
    },

    async handleFornecedorSelecionado(fornecedor) {
      if (!fornecedor) return

      await this.setOpcoesDoFornecedor(fornecedor)
    },

    close() {
      this.$emit('close')
    },

    async save() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.errorMessage('Preencha todos os campos obrigatórios!')
        return
      }

      this.overlay = true

      const payload = {
        descricao: this.contrato.descricao,
        numero_documento: this.contrato.numero_documento,
        data_inicio: moment(this.contrato.data_inicio).format(
          'YYYY-MM-DDTHH:mm:ss'
        ),
        data_fim: moment(this.contrato.data_fim).format('YYYY-MM-DDTHH:mm:ss'),
        fornecedor: this.contrato.fornecedor?.public_id ?? null,
        cliente: this.contrato.cliente?.public_id ?? null,
        terminal: this.contrato.terminal?.public_id ?? null,
        proprietario: this.empresaAtual.public_id,
        gate: this.isUnidadeGate
          ? this.empresaAtual.public_id
          : this.contrato.gate?.public_id ?? null,
        produto: this.contrato.produto?.id ?? null,
        sub_produto: this.contrato.subProduto?.id ?? null,
        navio: this.contrato.navio?.id ?? null,
        qt_peso: this.contrato.qt_peso ?? 0,
        tipo_operacao: this.contrato.tipo_operacao,
        active: true,
      }

      try {
        await this.addContrato(payload)
        this.successMessage('Contrato cadastrado com sucesso!')
        this.close()
      } catch (error) {
        this.errorMessage('Erro ao cadastrar contrato.')
        console.log(error)
      } finally {
        this.overlay = false
      }
    },

    async handleSelectDistribuicao(_, { item: distribuicao }) {
      const { subProduto, nPedidoImp } = distribuicao

      const produto = this.produtos.find(
        (produto) => produto.id === distribuicao.produto.id
      )

      this.pedido = Object.assign({}, this.pedido, {
        produto,
        subProduto: subProduto.id,
        numero_pedido_importacao: nPedidoImp,
        distribuicao: distribuicao.id,
      })

      this.showDistribuicoes = false
    },

    async getDistribuicoes() {
      const { navio } = this.pedido

      if (this.navioFoiSelecionado) {
        this.overlay = true

        setTimeout(async () => {
          this.distribuicoes = await DistribuicaoAPI.getDistribuicao(navio, {
            fornecedor: this.contrato.fornecedor.public_id,
          })

          this.showDistribuicoes = true
          this.overlay = false
        }, this.delay)
      }
    },
  },
  watch: {
    'contrato.produto': function (produto) {
      this.subProdutos = produto.subprodutos
    },
  },
}
</script>
